import { createSlice } from '@reduxjs/toolkit'
import { ldapLogin, login, logout } from 'services/auth'
import { AuthState } from 'store/types/auth'
import { FETCHING_STATUS } from 'utils/constants'

const initialState: AuthState = {
  authExpired: {
    isTokenExpired: false,
    lastPathname: null,
    lastPathState: null,
    reloadOnReauth: true,
  },
  error: undefined,
  loading: false,
  token: null,
  redirectTo: undefined,
  data: undefined,
}

const { reducer, actions } = createSlice({
  name: 'auth',
  initialState: {
    ...initialState,
    token: localStorage.getItem('token') || null,
  },
  reducers: {
    clear: () => {
      localStorage.removeItem('token')
      return initialState
    },
    setAuthExpired: (_state, { payload }: { payload: AuthState['authExpired'] }) => {
      localStorage.removeItem('token')
      return { ...initialState, authExpired: payload }
    },
    resetAuthExpired: (state) => ({ ...state, authExpired: initialState.authExpired }),
    resetLoginError: (state) => ({ ...state, error: initialState.error }),
    updateAuth: (state, { payload }) => {
      localStorage.setItem('token', payload)
      return { ...state, token: payload }
    },
    clearRedirect: (state) => ({ ...state, redirectTo: undefined }),
  },
  extraReducers: (builder) => {
    const onLoginPending = (state: AuthState) => ({
      ...state,
      loading: true,
    })
    const onLoginFulfilled = (
      state: AuthState,
      { payload }: { payload: ReturnType<typeof login.fulfilled>['payload'] },
    ) => {
      localStorage.setItem('isLoginMessageCleared', 'false')
      if (payload?.status === FETCHING_STATUS.success && payload.token) {
        localStorage.setItem('token', payload.token)
      }
      return {
        ...state,
        ...payload,
        loading: false,
        authExpired: initialState.authExpired,
      }
    }

    builder.addCase(login.pending, onLoginPending)
    builder.addCase(login.fulfilled, onLoginFulfilled)
    builder.addCase(ldapLogin.pending, onLoginPending)
    builder.addCase(ldapLogin.fulfilled, onLoginFulfilled)
    builder.addCase(logout.fulfilled, () => {
      localStorage.setItem('isLoginMessageCleared', 'false')
      localStorage.removeItem('token')
      return initialState
    })
  },
})

export default reducer
export { actions }
